import BaseModel from '@core/model';

export class FundStructure extends BaseModel {
    static entity = 'fundStructures';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default FundStructure;
